import {
  Box,
  type PopoverProps,
  type LinearProgressProps,
  LinearProgress,
  Popover,
} from '@mui/material';
import Typography from '@mui/material/Typography';

const popoverProps = {
  sx: {
    pointerEvents: 'none',
  },
  anchorPosition: {
    top: window.innerHeight / 2,
    left: window.innerWidth / 2,
  },
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'center',
    horizontal: 'center',
  },
  slotProps: {
    paper: {
      sx: {
        padding: 3,
        boxShadow: 3,
        borderRadius: 2,
        pointerEvents: 'auto',
      },
    },
  },
} as PopoverProps;

export default function ProgressBar({ percent }: { percent?: number | null }) {
  return (
    <Popover
      {...popoverProps}
      open={percent != null}
      anchorReference="anchorPosition"
      disableRestoreFocus
      disableScrollLock
      hideBackdrop
    >
      <Box width="20vw">
        <LinearProgressWithLabel value={percent || 0} />
      </Box>
    </Popover>
  );
}

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number },
) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth="auto">
        <Typography
          variant="body2"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
